<div *ngIf="showData">
    <div class="distance-time-container">
        <div class="section-container">
            <p>{{'distance' | translate}}</p>
            <div class="seccion-info">
                <img src="../../../../../assets/icons/route-lable-icon.svg" alt="route" />
                {{travelInfo?.Distance}}
            </div>
        </div>
        <div class="section-container">
            <p>{{'time_aprox' | translate}}</p>
            <div class="seccion-info">
                <img src="../../../../../assets/icons/clock.svg" alt="route" />
                {{travelInfo?.Time}}
            </div>
        </div>
    </div>
    <div class="split"></div>
</div>